import {cx} from "@emotion/css";
import $ from "jquery";
import keycode from "keycode"; 
import {useEffect, useState} from "react";
import {FloatingContactOptionsParameter, LeadFormData} from "@/components/overlay/ContactData";
import {body, dnbComLog, getIsUk, globalContactCta, isNotUndefined, LogSeverity, isNotUndefinedOrNull, trustArcGroupIsActive, TrustArcGroupId, windowOnLoadOrImmediate} from "@/shared/FunctionCore";

// import {LeadFormSharedComponent} from "@/HandleLeadForm/HandleLeadForm";
// import {addToRenderableData, RenderableData, renderIdentifierGeneric} from "@/RenderIdentifier";
import React from "react";
import LeadFormSharedComponent from "@/components/overlay/HandleLeadForm";
import { readCookie } from "@/shared/FunctionCore"; 
const infinityNumberClassName = "InfinityNumber";

interface PageProperties {
    "businessUnitName": string;
    "campaign": string;
    "canonicallogic": string;
    "container_tag": string;
    "ctaVersion": string;
    "dialerEligiblePage1": string;
    "eloquaCampaignId": string;
    "eloqua_form": string;
    "external_link_query_string_parameters": string | null | undefined;
    "formtype": string;
    "heroimage": string;
    "hide_leadform": string | null | undefined;
    "index_follow_options": string;
    "leadAssignmentGroup": string;
    "leadPriority": string;
    "leadSource1": string;
    "leadType": string;
    "manualReviewFlag1": string;
    "metadescription": string;
    "metatitle": string;
    "missionstatement": string;
    "ogtype": string;
    "override_form_settings": string;
    "parentcategory": string;
    "phonenumber": string;
    "phonenumberHide": string | null | undefined;
    "productInterest": string;
    "relatedproducts": string[];
    "sFDCLastCampaignID": string;
    "sFDCLastCampaignName": string;
    "siteOrigin": string;
    "solutionInterest": string;
    "submitButtonText": string;
    "submitter": string;
    "suppress_leadform_button": string | null | undefined;
    "tagline": string;
    "trackingcode": string;
    "twittercreator": string;
    "twittermetasite": string;
    "uNDUNSdToLDR1": string;
    "visitorFrom": string;
    "visitorFrom1": string;
}

interface FloatingContactOptionsData {
    "configPropsUseExternalLeadform": string | null | undefined;
    "ctaWithOrWithoutChatClass": string;
    "cta_Leadform_Title": string;
    "cta_Title_Mobile": string;
    "externalLeadformPageExtensionRewritePath": string;
    "external_leadform_page": string;
    "external_link_query_string_parameters": string;
    "href": string;
    "pageProperties": PageProperties;
    "phone_number_digits": string;
    "phonenumber": string;
}

const notEmptyString = (input: string | null | undefined) => typeof input === "string" && input.length > 0;

const emptyString = (input: string | null | undefined) => typeof input !== "string" || input.length === 0;

type FloatingContactOptionsComponentProps = FloatingContactOptionsParameter & {
    "isUk": boolean;
};

/**
 * Chat placeholder event click: Opening the cookie preferences view.
 */
const handleChatPlaceHolderClick = () => { 
    if (isNotUndefinedOrNull(window["truste"]) && isNotUndefinedOrNull(window["truste"].eu)) {
        window["truste"].eu.prefview();
    } 
};
 
const FloatingContactOptionsComponent = ({properties}) => {
    const {
        floatingContactOptionsData,
        isUk,
        leadFormData,
        leadFormNotHidden,
        isEmailDisplay,
        isPhoneDisplay
    } = properties;

    // State to manage chat cookie acceptance
    const [chatCookiesAccepted, setChatCookiesAccepted] = useState<boolean | null>(null); // null indicates loading/unknown

    const floatingContactOptionsDataAny: any = floatingContactOptionsData;

    const floatingContactOptionsDataFloatingContactOptionsData: FloatingContactOptionsData = floatingContactOptionsDataAny;

    const {
        configPropsUseExternalLeadform,
        cta_Leadform_Title,
        cta_Title_Mobile,
        ctaWithOrWithoutChatClass,
        external_leadform_page,
        externalLeadformPageExtensionRewritePath,
        href,
        pageProperties,
        phone_number_digits,
        phonenumber,
    } = floatingContactOptionsDataFloatingContactOptionsData;

    const {
        hide_leadform,
        phonenumberHide,
        suppress_leadform_button
    } = pageProperties;

    const externalLinkQueryStringParametersToUse =
        notEmptyString(pageProperties.external_link_query_string_parameters)
            ? pageProperties.external_link_query_string_parameters
            : floatingContactOptionsDataFloatingContactOptionsData.external_link_query_string_parameters;

    const externalLinkQueryStringParametersToUseTwo = typeof externalLinkQueryStringParametersToUse === "string" ? externalLinkQueryStringParametersToUse : "";

    const configPropertiesUseExternalLeadformIsEmpty = emptyString(configPropsUseExternalLeadform);
    const hideLeadformIsEmpty = emptyString(hide_leadform);
  
    useEffect(() => {
        windowOnLoadOrImmediate(
            $(window),
            () => {
                try {
                    if (isNotUndefinedOrNull(trustArcGroupIsActive(TrustArcGroupId.trustArcGroupFour))) {
                        const accepted = trustArcGroupIsActive(TrustArcGroupId.trustArcGroupFour);
                        setChatCookiesAccepted(accepted);
                    }
                } catch (er) {
                    dnbComLog(LogSeverity.ERROR, "TrustArc Error "+ er);
                }
            }); 
    
        // Hacky fix for invalid HTML that is causing CTA elements to go inside div.content
        const openClassName = "open";
        const overlayClassName = "overlay";
            $(() => {
                const $body = $(body);
                const $contactCta = $(".contact_cta");
                const $document = $(window.document);
                const $footer = $("footer");
                const $pageFirst = $("#page").first();
                const $window = $(window);
    
                const $contactCtaCta = $contactCta.find(".cta");
    
                $contactCta.first().appendTo($pageFirst);
    
                $(".lead-form.ctabar").first().appendTo($pageFirst);
    
                if ($(".ctabar").length > 0 && $contactCtaCta.length > 0) {
                    let contactBarHeight = 0;
    
                    const measureFooter = () => {
                        // "true" includes top and bottom margins in the calculated height
                        const contactCtaCtaOuterHeight = $contactCtaCta.outerHeight(true);
    
                        if (isNotUndefined(contactCtaCtaOuterHeight)) {
                            contactBarHeight = contactCtaCtaOuterHeight;
                        }
                    };
    
                    const offsetContactBar = () => {
                        measureFooter();
    
                        // Also see integrated_search_panel.js
                        const extraSpace = 10;
    
                        $footer.css("margin-bottom", contactBarHeight + extraSpace);
                    };
    
                    globalContactCta.exists = () => true;
                    globalContactCta.togglePanel = () => {
                        if ($contactCta.hasClass(openClassName)) {
                            $contactCta.removeClass(openClassName);
                            $body.removeClass(overlayClassName);
                        } else {
                            $contactCta.addClass(openClassName);
                            $body.addClass(overlayClassName);
                        }
                    };
    
                    if ($contactCta.length > 0) {
                        $window.on("resize", () => {
                            // Offset footer for fixed contact bar
                            offsetContactBar();
                        });
                    }
    
                    $(".two-step-cta-close-button").on("click", () => {
                        globalContactCta.togglePanel();
                    });
    
                    $document.on("keydown", (eventObject) => {
                        // Escape key
                        if (eventObject.which === keycode.codes.esc && $contactCta.hasClass(openClassName)) {
                            globalContactCta.togglePanel();
                        }
                    });
    
                    offsetContactBar();
                }
    
                if (hideLeadformIsEmpty && configPropertiesUseExternalLeadformIsEmpty) {
                    // Override default link behavior and toggle inline form
                    $(".contact_cta .form .open-form-overlay").on("click", (cl) => {
                        cl.preventDefault();
                        cl.stopPropagation();
    
                        const $currentTarget = $(cl.currentTarget);
    
                        globalContactCta.togglePanel();
    
                        const ariaExpanded = $currentTarget.attr("aria-expanded");
    
                        let newAriaExpanded;
    
                        if (ariaExpanded === "true") {
                            newAriaExpanded = "false";
                        } else {
                            newAriaExpanded = "true";
    
                            $(".lead-form .subtitle").trigger("focus");
                        }
    
                        $currentTarget.attr("aria-expanded", newAriaExpanded);
                    });
                }
            });            
    }, []);

    return (
        <>
            <div className="contact_cta">
                <section className={`cta  ${ctaWithOrWithoutChatClass} ${!chatCookiesAccepted ? "cta-without-chat": ""}`}>
                    { isPhoneDisplay ? (
                        <div className={`contact-method call`}>
                            <a
                                className={`${isUk} ? infinityNumberClassName : void 0`}
                                data-ict-silent-replacements={isUk ? "true" : void 0}
                                href={href}>
                                <div className={`text-container phone`}>
                                    <div className={`floatingContactOptionsPhoneNumber ${isUk} ? infinityNumberClassName : void 0`}>
                                        {phonenumber}
                                    </div>

                                    <div className={`floatingContactOptionsPhoneLogo ${isUk} ? infinityNumberClassName : void 0`} />
                                </div>
                            </a>
                        </div>
                    ) : (
                        <></>
                    )}

                    {((hideLeadformIsEmpty && isEmailDisplay) || isEmailDisplay) ? (
                        <div className={`contact-method form`}>
                            {
                                // TODO aria-label not localized
                            }

                            {configPropertiesUseExternalLeadformIsEmpty ? (
                                <button
                                    aria-label="Button to open contact form"
                                    className="open-form-overlay"
                                    type="button">
                                    <span className={emptyString(suppress_leadform_button) ? "new-form-image" : "new-form-image-hidden"} />
                                </button>
                            ) : (
                                <>
                                    {notEmptyString(external_leadform_page) ? (
                                        <a
                                            className={`button v1 ctaLeadFormLink`}
                                            href={externalLeadformPageExtensionRewritePath + externalLinkQueryStringParametersToUseTwo}>
                                            <div className="icon" />

                                            <span className={`text desktop`}>
                                                {cta_Leadform_Title}
                                            </span>

                                            <span className={`text mobile`}>
                                                {cta_Title_Mobile}
                                            </span>
                                        </a>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            )}
                        </div>
                    ) : (
                        <></>
                    )} 
                    {chatCookiesAccepted === false && (
                        <div className={`contact-method placeHolderChatWidget`}> 
                            <button
                                aria-label="Button to open chatcookie settings"
                                className="openChatCookieSettings"
                                onClick={handleChatPlaceHolderClick}
                                type="button">
                                <span className="new-chat-placeholder-image" />
                            </button>
                        </div>
                    )}
                </section>
            </div>

            {
                // Test to render lead form
            }

            {
                leadFormNotHidden
                    ? (
                        <section className={`lead-form ctabar`}>
                            <div className="container">
                                <h1></h1>
                                <button
                                    aria-label="Close"
                                    className={"two-step-cta-close-button"}
                                    type="button" />

                                <LeadFormSharedComponent 
                                    fromFloatingContactOptions={true}
                                    leadFormData={leadFormData}
                                />
                            </div>
                        </section>
                    )
                    : <></>
            }
        </>
    );
};

// const leadFormDataWrapper: {leadFormData: LeadFormData | undefined} = {
//     "leadFormData": void 0
// };

// const floatingContactOptions = (renderableData: RenderableData<FloatingContactOptionsParameter>): void => {
//     // TODO For roiCalculator
//     leadFormDataWrapper.leadFormData = renderableData.data.leadFormData;

//     const isUk = getIsUk();

//     renderIdentifierGeneric(
//         FloatingContactOptionsComponent,
//         addToRenderableData(
//             renderableData,
//             {
//                 "isUk": isUk,
//             }
//         )
//     );
// };

// export {floatingContactOptions, leadFormDataWrapper};
export default FloatingContactOptionsComponent;